import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import {
  GooglePayCreditCardNetworks as GooglePayCreditCardNetworksServer,
  IGooglePayPaymentMethod as IGooglePayPaymentMethodServer,
} from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { GooglePayCreditCardNetworks, GooglePayPaymentMethod } from '../../../types/PaymentMethods';

const GooglePayCreditCardNetworksMap: Record<GooglePayCreditCardNetworksServer, GooglePayCreditCardNetworks> = {
  [GooglePayCreditCardNetworksServer.Amex]: GooglePayCreditCardNetworks.Amex,
  [GooglePayCreditCardNetworksServer.Discover]: GooglePayCreditCardNetworks.Discover,
  [GooglePayCreditCardNetworksServer.Interac]: GooglePayCreditCardNetworks.Interac,
  [GooglePayCreditCardNetworksServer.Jcb]: GooglePayCreditCardNetworks.Jcb,
  [GooglePayCreditCardNetworksServer.MasterCard]: GooglePayCreditCardNetworks.MasterCard,
  [GooglePayCreditCardNetworksServer.Visa]: GooglePayCreditCardNetworks.Visa,
  [GooglePayCreditCardNetworksServer.Electron]: GooglePayCreditCardNetworks.Electron,
  [GooglePayCreditCardNetworksServer.Elo]: GooglePayCreditCardNetworks.Elo,
  [GooglePayCreditCardNetworksServer.EloDebit]: GooglePayCreditCardNetworks.EloDebit,
  [GooglePayCreditCardNetworksServer.Maestro]: GooglePayCreditCardNetworks.Maestro,
};

function mapSupportedNetworksToCommon(
  supportedNetworks: GooglePayCreditCardNetworksServer[],
): GooglePayCreditCardNetworks[] {
  return supportedNetworks && supportedNetworks.map((value) => GooglePayCreditCardNetworksMap[value]);
}

export function mapGooglePayPaymentMethodToCommon(
  paymentMethod: IGooglePayPaymentMethodServer,
): GooglePayPaymentMethod {
  const { merchantCountry, allowCardNetworks, allowedAuthMethods } = paymentMethod[PaymentMethod.GooglePay];

  return {
    [PaymentMethod.GooglePay]: {
      merchantCountry,
      allowedAuthMethods,
      allowCardNetworks: mapSupportedNetworksToCommon(allowCardNetworks),
    },
  };
}
